'use client';

import { useInfiniteQuery } from '@tanstack/react-query';
import { IPost } from '../../../models/ICategory';
import { IPaginatedData } from '../../../models/ICommon';
import { apiService } from '../../../services/ApiService';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Post from '../../components/Post';
import Loader from '../../components/svg/Loader';
import { IAuthor } from '../../../models/IAuthor';
import LoadMoreButton from '../../components/LoadMoreButton';
import { deleteQueryParams, setQueryParam } from '../../../utils/querystring';


interface Props {
  writer: IAuthor;
  initialPosts: IPaginatedData<IPost>;
}

export default function PostsWrapper({initialPosts, writer}:Props) {
  const [page, setPage] = useState(initialPosts.page);

  const {
    data,
    isFetching,
    isLoading,
    fetchNextPage,
    hasPreviousPage,
    fetchPreviousPage,
    hasNextPage
  } = useInfiniteQuery({
    retry: false,
    initialData: () => {
      return {
        pageParams: [undefined, page],
        pages: [initialPosts]
      }
    },
    enabled: false,
    queryKey: ['writer-posts', writer.uniqueCode],
    queryFn: async ({ pageParam = page }) => {
      const result = await apiService.getWriterPage(writer.uniqueCode,{ page: pageParam as number, pageSize: initialPosts.pageSize });
      const isPrev = page > pageParam;
      if (isPrev) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
      setPage(result.posts.page);
      if (result.posts.page > 1) setQueryParam({page: result.posts.page})
      else deleteQueryParams('page');
      return result.posts;
    },
    getPreviousPageParam: (firstPage, allPages) => {
      // If the first page in our data array is page 1, there is no previous
      return firstPage.page > 1 ? firstPage.page - 1 : undefined;
    },
    getNextPageParam: (lastPage, allPages, lastPageParam, allPagesParam) => {
      if (!lastPage) return 1;
      return lastPage.page < lastPage.totalPages ? lastPage.page + 1 : undefined;
    },
    initialPageParam: page
  });


  useEffect(() => {
    if (page > 1) setQueryParam({page});
  }, [page]);
const totalData = useMemo(() => {
  const allPosts = (data?.pages?.map(p => p.data).flat(Infinity) || []) as IPost[];
  return Array.from(
    new Map(allPosts.map(post => [post.uniqueCode, post])).values()
  );
}, [data]) as IPost[];


  return (
    <div className='flex flex-col gap-[24px]'>
      <div className='h-[1px] w-full bg-gray-0 dark:bg-lightBorder hidden desktop:block' />

      <div className='grid grid-cols-1 tablet:grid-cols-3 desktop:grid-cols-4 gap-[24px]'>
      {totalData.map((p,i) => {
        
        return (
     <Post 
     isLarge
      badge={{mobile: 'image', tablet: 'image', desktop: 'image'}}
     newsType={p.newsType}
                   type={p.type}
                   uniqueCode={p.uniqueCode}
                   key={p.uniqueCode}
                   classNames={{
                     wrapper: 'flex-col items-center tablet:items-start h-full rounded-[12px]',
                     image: 'tablet:h-[110px] w-fit mb-0 w-full tablet:h-[unset]',
                     contentContainer: 'h-full p-[16px]',
                     title: 'line-clamp-4 h5',
                     
                   }} 
                   image={{src: p.imageUrls.url, fill: true, sizes: '', alt: p.title, priority: i === 0, className: 'rounded-tl-[12px] rounded-tr-[12px]'}} title={p.title} category={p.category}
                   hide={{category: true}}
                   thumbnail={p.imageUrls.thumbUrl}
                   />
      )
})}
</div>

<div className='flex items-center justify-center mx-auto gap-[12px]'>
  {isLoading || isFetching ? <Loader/>: (
    <>
    {hasNextPage ? <LoadMoreButton text='المزيد' onClick={fetchNextPage}/> : null}
    {hasPreviousPage ? <LoadMoreButton text='السابق' onClick={fetchPreviousPage}/> : null}
    </>
  )}
</div>
    </div>
  )
}